import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { ProvisionImpairmentDetail } from './ProvisionImpairmentDetail/ProvisionImpairmentDetail'
import { ProvisionImpairmentMain } from './ProvisionImpairmentMain'
import { ProvisionImpairmentForm } from './ProvisionImpairmentForm/ProvisionImpairmentForm'

const provisionImpairmentRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/provision-for-impairment/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/provision-for-impairment',
    },
    component: <ProvisionImpairmentMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/provision-for-impairment/add',
    },
    component: <ProvisionImpairmentForm formMode="add" type="ASSETS_REGISTRATION" />,
  },
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/provision-for-impairment/edit',
    },
    component: <ProvisionImpairmentForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/provision-for-impairment/resubmit',
    },
    component: <ProvisionImpairmentForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/provision-for-impairment/detail',
    },
    component: <ProvisionImpairmentDetail />,
  },
]

export default provisionImpairmentRoutes
